import React from "react";
import colors from "@streeteasy/design-system/deprecated/colors";
import { bool, node, shape } from "prop-types";

import StickyBannerContainer from "src/shared/components/StickyBannerContainer";
import buildingProps from "src/shared/utilities/graphql/buildingProps";
import listingProps from "src/shared/utilities/graphql/listingProps";

import StickyContactContainer from "../StickyContactContainer";

const StickyButtons = ({ building, children, isMobile, listing }) => (
  <StickyBannerContainer backgroundColor={colors.pureWhite} isMobile={isMobile}>
    <StickyContactContainer
      building={building}
      isMobile={isMobile}
      listing={listing}
    >
      {children}
    </StickyContactContainer>
  </StickyBannerContainer>
);

StickyButtons.propTypes = {
  building: shape(buildingProps),
  children: node.isRequired,
  isMobile: bool,
  listing: shape(listingProps)
};

StickyButtons.defaultProps = {
  building: null,
  isMobile: false,
  listing: null
};

export default StickyButtons;
